Customer.Dashboard ||= {}

class Customer.Dashboard.TicketEmptyDetailBox extends Backbone.View
  template: JST["backbone/templates/customer/ticket/detail/box/ticket_greyed_details_box"]

  render: ->
    @$el.html(@template())
    @
